import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import { TextField } from 'libs/forms/views/fieldTypes/text';

import { Name, NameInput } from 'apps/profile/views/profileName.styles';

export const ProfileName = observer(({ app, formStore, fieldName }) => {
  if (!app.editing) {
    return <Name>{app[fieldName]}</Name>;
  }
  return (
    <TextField
      fieldStore={formStore.fieldStores.get(fieldName)}
      editComponent={NameInput}
      validationPosition={{ top: '5px', right: '-25px' }}
    />
  );
});

ProfileName.propTypes = {
  app: PropTypes.object,
  fieldStore: PropTypes.object,
  autoFocus: PropTypes.bool,
  placeholder: PropTypes.string,
  value: PropTypes.string,
};
